module.exports = __webpack_public_path__ + "img/banner_3.0c5cbeb1.jpg";